<template>
  <div class="warpper">
    <!-- 搜索 -->
    <div style="margin-bottom: 10px">
      <el-form :model="searchForm" ref="searchForm" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="计划名称" prop="title">
              <el-input
                v-model="searchForm.title"
                size="medium"
                placeholder="请输入计划名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="时间范围" prop="time">
              <el-date-picker
                style="width: 100%"
                v-model="timeList"
                size="medium"
                type="daterange"
                :picker-options="pickerOptions"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="" prop="patrolLevelId">
              <el-select clearable filterable v-model="searchForm.status" placeholder="请选择状态">
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button
              size="small"
              @click="onLoad(1)"
              type="primary"
              icon="el-icon-search"
              style="width: 90px; margin-left: 15px"
              >搜索</el-button
            >
            <el-button
              size="small"
              @click="restSearch"
              type="danger"
              style="width: 90px"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin: 0 20px 20px 20px">
      <el-button
        size="small"
        plain
        type="primary"
        icon="el-icon-plus"
        @click="addCharacter"
        style="width: 90px"
        >新增</el-button
      >
    </div>
    <el-table :data="list" style="width: 100%" border>
      <el-table-column prop="title" label="计划名称" align="center">
      </el-table-column>
      <el-table-column
        prop="patrolRouteTitle"
        label="巡更路线名称"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="takeEffectTime"
        label="生效时间"
        align="center"
        width="160"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        width="160"
        :formatter="statusType"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
        width="160"
      >
      </el-table-column>
      <el-table-column fixed="right" align="center" label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="updataCharacter(scope.row)"
            >修改</el-button
          >

          <el-button @click="del(scope.row)" type="text" size="small"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <div class="block" style="margin-top: 15px">
      <el-pagination
        align="center"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 新增模态框 -->
    <el-dialog
      :title="modalTitle"
      :close-on-click-modal="false"
      :visible.sync="isAddModal"
      width="70%"
    >
      <el-form
        ref="form"
        :model="addData"
        label-width="90px"
        :rules="addDataRules"
        label-position="center"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="巡更计划名称" prop="title" label-width="120px">
              <el-input
                v-model="addData.title"
                placeholder="请输入巡更计划名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status" label-width="120px">
              <el-select clearable filterable v-model="addData.status" placeholder="请选择">
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="计划生效时间"
              prop="takeEffectTime"
              label-width="120px"
            >
              <el-date-picker
                v-model="addData.takeEffectTime"
                type="date"
                :picker-options="{
                  disabledDate: (time) =>
                    time.getTime() < new Date(new Date().setHours(0, 0, 0, 0)),
                }"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="巡更路线"
              prop="patrolRouteList"
              label-width="120px"
            >
              <div class="patrolList">
                <div
                  class="partolLi"
                  v-for="(item, ind) in addData.patrolRouteList"
                  :key="ind"
                >
                  <el-select clearable filterable v-model="item.id" placeholder="请选择">
                    <el-option
                      v-for="item in routeList"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <span v-if="item.isDefault == 1">默认</span>
                  <span
                    v-else
                    style="color: #0089ff"
                    @click="optionDefault(ind)"
                    >设为默认</span
                  >
                  <el-button
                    type="danger"
                    icon="el-icon-minus"
                    @click="reducePartol(item, ind)"
                    v-if="addData.patrolRouteList.length > 1"
                    size="small"
                  ></el-button>
                  <el-button
                    type="primary"
                    icon="el-icon-plus"
                    @click="addPartol"
                    v-if="ind == addData.patrolRouteList.length - 1"
                    size="small"
                  ></el-button>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="巡更时间段"
              prop="timeSlot"
              label-width="120px"
            >
              <div class="timeSlot">
                <div class="current day">
                  <div class="title">白班</div>
                  <div class="timeCont">
                    <div class="timeList">
                      <div class="timeLi">
                        <div>
                          <span style="color: red; margin: 0">*</span> 开始时间
                        </div>
                        <el-time-picker
                          v-model="addData.whiteBeginTime"
                          value-format="HH:mm:ss"
                          placeholder="开始时间"
                        >
                        </el-time-picker>
                      </div>
                      <span>-</span>
                      <div class="timeLi">
                        <div>
                          <span style="color: red; margin: 0">*</span> 结束时间
                        </div>
                        <el-time-picker
                          v-model="addData.whiteEndTime"
                          value-format="HH:mm:ss"
                          placeholder="结束时间"
                        >
                        </el-time-picker>
                      </div>
                    </div>
                    <div class="option">
                      <div class="optList">
                        <div class="optLi">
                          <div>
                            <span style="color: red">*</span>
                            巡更间隔（小时/次）
                          </div>
                          <el-input
                            type="number"
                            min="0"
                            v-model="addData.whitePeriod"
                          ></el-input>
                        </div>
                        <div class="optLi">
                          <div>
                            <span style="color: red">*</span> 允许超时（分钟）
                          </div>
                          <el-input
                            type="number"
                            min="0"
                            v-model="addData.whiteOverMinute"
                          ></el-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="" prop="timeSlot" label-width="120px">
              <div class="timeSlot">
                <div class="current night">
                  <div class="title">晚班</div>
                  <div class="timeCont">
                    <div class="timeList">
                      <div class="timeLi">
                        <div>
                          <span style="color: red; margin: 0">*</span> 开始时间
                        </div>
                        <el-time-picker
                          v-model="addData.nightBeginTime"
                          placeholder="开始时间"
                          value-format="HH:mm:ss"
                        >
                        </el-time-picker>
                      </div>
                      <span>-</span>
                      <div class="timeLi">
                        <div>
                          <span style="color: red; margin: 0">*</span> 结束时间
                        </div>
                        <el-time-picker
                          v-model="addData.nightEndTime"
                          placeholder="结束时间"
                          value-format="HH:mm:ss"
                        >
                        </el-time-picker>
                      </div>
                    </div>
                    <div class="option">
                      <div class="optList">
                        <div class="optLi">
                          <div>
                            <span style="color: red">*</span>
                            巡更间隔（小时/次）
                          </div>
                          <el-input
                            type="number"
                            min="0"
                            v-model="addData.nightPeriod"
                          ></el-input>
                        </div>
                        <div class="optLi">
                          <div>
                            <span style="color: red">*</span> 允许超时（分钟）
                          </div>
                          <el-input
                            type="number"
                            min="0"
                            v-model="addData.nightOverMinute"
                          ></el-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isAddModal = false">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="btnLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      list: [],
      addDataRules: {
        title: [
          { required: true, message: "请输入巡更计划名称", trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择路线状态", trigger: "blur" },
        ],
        takeEffectTime: [
          { required: true, message: "请选择计划生效时间", trigger: "blur" },
        ],
        patrolRouteList: [
          { required: true, message: "请选择巡更路线", trigger: "blur" },
        ],
      },
      timeList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      addData: {
        status: 1,
        whiteBeginTime: "",
        whiteEndTime: "",
        nightBeginTime: "",
        nightEndTime: "",
        nightOverMinute: "",
        nightPeriod: "",
        whiteOverMinute: "",
        whitePeriod: "",
        title: "",
        patrolRouteList: [
          {
            id: "",
            isDefault: 1,
            routeTitle: "",
          },
        ],
      },
      statusList: [
        {
          id: 1,
          name: "启用",
        },
        {
          id: -1,
          name: "禁用",
        },
      ],
      isAddModal: false,
      btnLoading: false,
      isShowloading: false,
      modalTitle: "新增",
      searchForm: {},
      routeList: [],
    };
  },
  mounted() {
    this.onLoad();
    this.patrolRouteList();
  },
  methods: {
    optionDefault(ind) {
      this.addData.patrolRouteList.forEach((res, index) => {
        res.isDefault = index == ind ? 1 : -1;
      });
    },
    // 添加路线选择框
    addPartol() {
      let obj = {
        id: "",
        isDefault: -1,
        routeTitle: "",
      };
      this.addData.patrolRouteList.push(obj);
    },
    // 删除路线
    reducePartol(item, ind) {
      if (item.isDefault == 1) {
        this.$confirm("您确定要删除默认路线吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.addData.patrolRouteList.splice(ind, 1);
          this.addData.patrolRouteList[0].isDefault = 1;
        });
      } else {
        this.addData.patrolRouteList.splice(ind, 1);
      }
    },
    // 巡更路线列表
    patrolRouteList() {
      let data = {
        size: 100,
        current: 1,
      };
      this.$Apis.patrolRouteList(data).then((res) => {
        if (res.code == 200) {
          this.routeList = res.data.list;
        }
      });
    },
    statusType(row) {
      if (row.status == 1) {
        return "启用";
      } else {
        return "禁用";
      }
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let arr = [];
          this.addData.patrolRouteList.forEach((item) => {
            if (!item.id) {
              arr.push(item);
            }
            this.routeList.forEach((it) => {
              if (item.id == it.id) {
                item.routeTitle = it.title;
              }
            });
          });
          if (arr.length > 0) {
            this.$message.warning("请选择巡更路线");
            return;
          }
          let patrolRouteIds = this.addData.patrolRouteList
            .map((item) => item.id)
            .join(",");
          let {
            nightBeginTime,
            nightEndTime,
            nightPeriod,
            nightOverMinute,
            status,
            takeEffectTime,
            title,
            whiteBeginTime,
            whiteEndTime,
            whiteOverMinute,
            whitePeriod,
            patrolRouteList,
          } = this.addData;
          var data = {
            id: this.addData.id || "",
            nightEndTime,
            nightBeginTime,
            nightPeriod,
            status,
            takeEffectTime,
            title,
            whiteBeginTime,
            whiteEndTime,
            whiteOverMinute,
            whitePeriod,
            type: 1,
            nightOverMinute,
            patrolRouteList,
            patrolRouteIds,
          };
          let wnewTime = new Date(
            takeEffectTime + " " + nightBeginTime
          ).getTime();
          let bnewTime = new Date(
            takeEffectTime + " " + whiteEndTime
          ).getTime();
          let wendTime = new Date(
            takeEffectTime + " " + nightEndTime
          ).getTime();
          let bendTime = new Date(
            takeEffectTime + " " + whiteBeginTime
          ).getTime();
          if (wnewTime < bnewTime) {
            this.$message.warning("晚班开始时间不能小于白班结束时间");
            return;
          }
          if (wendTime > bendTime) {
            this.$message.warning("晚班结束时间不能大于白班开始时间");
            return;
          } 
          let text = '巡更计划将于设置的"计划生效时间"的当日凌晨1点生效'
          if(new Date(takeEffectTime).getTime() < new Date().getTime()){
            text = "巡更计划将于次日凌晨1点生效"
          }
          this.$confirm(text, "提示", {
            confirmButtonText: "确定",
            type: "warning",
          }).then(() => {
            this.btnLoading = true;
            this.$Apis.patrolPlanAddUp(data).then((res) => {
              this.btnLoading = false;
              if (res.code == 200) {
                this.onLoad();
                this.isAddModal = false;
                this.$message.success("操作成功");
              } else {
                this.$message.warning(res.msg);
              }
            });
          });
        }
      });
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.addData.status = 1;
      this.addData.whiteBeginTime = "08:00:00";
      this.addData.whiteEndTime = "18:00:00";
      this.addData.nightBeginTime = "19:00:00";
      this.addData.nightEndTime = "07:00:00";
      this.addData.nightOverMinute = 30;
      this.addData.nightPeriod = 3;
      this.addData.whiteOverMinute = 30;
      this.addData.whitePeriod = 3;
      this.addData.patrolRouteList = [
        {
          id: "",
          isDefault: 1,
          routeTitle: "",
        },
      ];
      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    onLoad(e) {
      if (this.timeList) {
        this.searchForm.startTime = this.timeList[0];
        this.searchForm.endTime = this.timeList[1];
      }
      let page = {
        size: this.pageSize,
        current: e || this.currentPage,
        ...this.searchForm,
      };
      this.isShowloading = true;
      this.$Apis.patrolPlanList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item) => {
            // console.log(item)
            item.patrolRouteList = JSON.parse(item.patrolRouteList);
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.list = list;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.addData.nightBeginTime = row.nightBeginTime.split(" ")[1];
      this.addData.nightEndTime = row.nightEndTime.split(" ")[1];
      this.addData.whiteBeginTime = row.whiteBeginTime.split(" ")[1];
      this.addData.whiteEndTime = row.whiteEndTime.split(" ")[1];
      this.addData.takeEffectTime = row.takeEffectTime.split(" ")[0];
      this.modalTitle = "修改";
      this.isAddModal = true;
    },
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.patrolPlandel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.timeList = [];
      this.onLoad(1);
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
  },
};
</script>
  
  <style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding-bottom: 0;
}
.warp {
  display: flex;
  .left {
    width: 100%;
    margin-right: 10px;
    box-sizing: border-box;
  }
  .right {
    width: 28%;
    border-left: 1px solid #f5f5f5;
    padding-left: 10px;
    box-sizing: border-box;
    .xgList {
      .li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 5px;
        box-sizing: border-box;
        cursor: pointer;
        transition: all 0.3s;
        border-radius: 2px;
        &:hover {
          color: #fff;
          background: #409eff;
        }
        i {
          cursor: pointer;
        }
      }
    }
  }
}
.timeSlot {
  display: flex;
  align-items: center;
  width: 100%;
  .current {
    .timeCont {
      .timeList {
        display: flex;
        align-items: flex-end;
        span {
          margin: 0 10px;
        }
      }
      .option {
        .optList {
          display: flex;
          align-items: center;
          .optLi {
            margin-right: 52px;
          }
        }
      }
    }
  }
}
.patrolList {
  .partolLi {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
    span {
      width: 80px;
      margin: 0 10px;
      cursor: pointer;
    }
  }
}
</style>